export const API_URL_BASE = 'https://api.insaider.io/api/';
